import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from '../../styles/theme';
import { AuthContext } from '../../context/AuthContext';

const BottomNavContainer = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: ${theme.colors.white};
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid ${theme.colors.softGray};
  z-index: 1000;
`;

const NavItem = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: ${props => props.$active ? theme.colors.deepNavy : theme.colors.slateGray};
`;

const NavIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.$active ? 'rgba(255, 209, 0, 0.8)' : 'transparent'};
  border-radius: 50%;
`;

const NavIconImage = styled.img`
  width: 20px;
  height: 20px;
`;

const NavIconText = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

const NavLabel = styled.span`
  font-size: ${theme.typography.fontSizes.small};
  margin-top: 4px;
`;

const navItems = [
  { path: '/', labelKey: 'nav.home', icon: '/icons/icon_home.png' },
  { path: '/log-activity', labelKey: 'nav.logActivity', icon: '/icons/icon_activity.png' },
  { path: '/progress', labelKey: 'nav.progress', icon: '/icons/icon_progress.png' },
  { path: '/profile', labelKey: 'nav.profile', icon: '/icons/icon_profile.png' },
];

export const BottomNav = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { currentUser } = useContext(AuthContext);
  const ADMIN_EMAIL = 'dev@lightandcover.org';
  const isAdmin = currentUser?.email === ADMIN_EMAIL;

  return (
    <BottomNavContainer>
      {navItems.map(item => (
        <NavItem key={item.path} to={item.path} $active={location.pathname === item.path}>
          <NavIcon $active={location.pathname === item.path}>
            <NavIconImage src={item.icon} alt={t(item.labelKey)} />
          </NavIcon>
          <NavLabel>{t(item.labelKey)}</NavLabel>
        </NavItem>
      ))}
      {isAdmin && (
        <NavItem to="/admin/feedback" $active={location.pathname === '/admin/feedback'}>
          <NavIcon $active={location.pathname === '/admin/feedback'}>
            <NavIconText>⚙</NavIconText>
          </NavIcon>
          <NavLabel>{t('nav.admin')}</NavLabel>
        </NavItem>
      )}
    </BottomNavContainer>
  );
};
